var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('title')))]),_c('span',[_vm._v(_vm._s(_vm.$t('description')))]),_c('router-link',{attrs:{"tag":"button","to":"/"}},[_vm._v(_vm._s(_vm.$t('buttonText')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }